<template>
  <v-card>
    <div class="pa-6">
      <div class="d-flex justify-end align-center pb-6">
        <v-spacer></v-spacer>
        <ClassReportExport :data="reports" :exam="exam" />
      </div>

      <v-tabs v-model="activeTab" active-class="tab-active" background-color="transparent" show-arrows>
        <v-tab v-for="(subject, index) in reports" :key="index" class="tab-default">
          {{ subject.subjectGroup }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="(subject, index) in reports" :key="index">
          <v-data-table
            item-key="id"
            :headers="headers"
            :items="subject.classReports"
            :loading="loading"
            hide-default-footer
            :items-per-page="-1"
            fixed-header
          >
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { ExamMark } from '../../plugins/api'
import ClassReportExport from './export/ClassReportExport.vue'

const originHeaders = [
  { text: 'Lớp', value: 'class', align: 'left', sortable: false },
  { text: 'GVGD', value: 'teacher', align: 'left', sortable: false },
  { text: 'Số HS', value: 'totalMarks', align: 'left', sortable: false },
  { text: 'VT', value: 'absent', align: 'left', sortable: false },
  { text: 'Max', value: 'max', align: 'left', sortable: false },
  { text: 'Min', value: 'min', align: 'left', sortable: false },
  { text: 'TB', value: 'average', align: 'left', sortable: false },
  { text: 'Xếp thứ', value: 'rank', align: 'left', sortable: true }
]

export default {
  props: {
    room: Object,
    query: Object,
    exam: Object,
    subjects: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      reports: [], // This will hold the array of subject groups with their classReports
      activeTab: 0 // Active tab index
    }
  },
  components: { ClassReportExport },
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'countMarks']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      try {
        const reports = await ExamMark.getReportByClass(this.query)
        this.reports = reports // Assign fetched reports to the component's data
      } catch (error) {
        console.log(error)
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    }
  },
  watch: {
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  }
}
</script>
